import { orange, grey } from "@material-ui/core/colors";

const orangeVariant = {
  name: "Orange",
  palette: {
    primary: {
      main: orange[800],
      contrastText: "#FFF"
    },
    secondary: {
      main: orange[600],
      contrastText: "#FFF"
    }
  },
  header: {
    color: grey[500],
    background: "#FFF",
    search: {
      color: grey[800]
    },
    indicator: {
      background: orange[600]
    }
  },
  sidebar: {
    color: "#FFF",
    background: orange[700],
    header: {
      color: "#FFF",
      background: orange[800],
      brand: {
        color: "#FFFFFF"
      }
    },
    footer: {
      color: "#FFF",
      background: orange[800],
      online: {
        background: "#FFF"
      }
    },
    category: {
      fontWeight: 400
    },
    badge: {
      color: "#000",
      background: "#FFF"
    }
  },
  body: {
    background: "#F7F9FC"
  },
  footer: {
    color: grey[800]
  }
};

const variants = [
  orangeVariant
];

export default variants;
